module.exports = __webpack_public_path__ + "img/whatsApp-white.f9d25762.svg";